module.exports = __webpack_public_path__ + "static/Jan Szczepkowski razem z żoną Marią-fd9c6550ca73e79a3e2200442218d6ef.jpg";